import { Flex } from '@chakra-ui/react';
import Button from '@components/interactive/Button';
import CallUsButton from '@components/interactive/CallUsButton';
import { Routes } from '@constants/routes';

const CallToAction = ({ ...rest }) => {
  return (
    <Flex flexDirection={['column', 'column', 'row']} gap={[3, 3, 4]} w="100%" alignItems="stretch" {...rest}>
      <CallUsButton flex={1} />
      <Button flex={1} width="100%" variant="secondary" href={Routes.guideIntroduction}>
        Shop Plans
      </Button>
    </Flex>
  );
};

export default CallToAction;
